import { render, staticRenderFns } from "./ModalCorrectSingleChoice.vue?vue&type=template&id=c070453a&scoped=true&lang=pug&"
import script from "./ModalCorrectSingleChoice.vue?vue&type=script&lang=ts&"
export * from "./ModalCorrectSingleChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070453a",
  null
  
)

export default component.exports